import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { getMarketStore } from '@/store/use-markets-store';
import { bigIntToNum, formatBigInt } from '@/utils/value-format';

type Props = {
  symbol: string;
};

export default function MarkPrice({ symbol }: Props) {
  const { markPrice, priceDecimals } = useStore(
    getMarketStore(symbol),
    useShallow((state) => ({
      markPrice: state.marketData.markPrice,
      priceDecimals: state.marketSpec.priceDecimals,
    })),
  );
  return formatBigInt(markPrice, priceDecimals, {
    style: 'currency',
    digits: Number(priceDecimals),
  });
}

export const markPriceAccessorFn = (symbol: string) => {
  const {
    marketData: { markPrice },
    marketSpec: { priceDecimals },
  } = getMarketStore(symbol).getState();
  return bigIntToNum(markPrice, priceDecimals);
};
